import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useParams } from 'react-router-dom';
import { Loading } from 'src/components/Loading';
import { CustomerDeliveryRequestContainer } from 'src/containers/CustomerDeliveryRequestContainer/CustomerDeliveryRequestContainer';
import { useCanThisShippingCreateDeliveryRequest } from 'src/hooks/useCanThisShippingCreateDeliveryRequest';
import { useDeliveryPublicColiInfo } from '../DeliveryPublicColiInfo/hooks';
import { TrackingColiPublicAuthFom } from '../TrackingColisPublic/components/TrackingColiPublicAuthFom';
import { useTrackingColiPublicForm } from '../TrackingColisPublic/components/TrackingColiPublicAuthFom/useTrackingColiPublicForm';
import { NoticeBlock } from './NoticeBlock';

export const PublicClientDeliveryRequest = () => {
  const params = useParams<{ tracking: string; code: string }>();
  const { isLoading, error, fetchData, data } = useDeliveryPublicColiInfo({ includeTimeSlots: true });
  const { control, errors, handleSubmit } = useTrackingColiPublicForm(params);

  const canCreateRequest = useCanThisShippingCreateDeliveryRequest({ shipping: data });

  useEffect(() => {
    if (params) {
      fetchData({ tracking: params.tracking, code: params.code });
    }
  }, [params, fetchData]);

  useEffect(() => {
    if (data && params) {
      ReactGA.event({
        category: 'Receiver',
        action: 'InfoColis',
        label: `${params.tracking}/${params.code}`,
      });
    }
  }, [data, params]);

  if (isLoading) {
    return <Loading />;
  }

  if (!data) {
    return (
      <TrackingColiPublicAuthFom
        onSubmit={fetchData}
        error={error}
        errors={errors}
        handleSubmit={handleSubmit}
        control={control}
      />
    );
  }

  if (data?.alreadyHasClientDeliveryRequest) {
    return (
      <NoticeBlock
        type="normal"
        text="client-delivery-requests.shipping-already-exist"
        code={params.code}
        tracker={params.tracking}
        shipping={data}
      />
    );
  }

  if (!canCreateRequest) {
    return (
      <NoticeBlock
        type="error"
        text="client-delivery-requests.cant-create-request"
        code={params.code}
        tracker={params.tracking}
        shipping={data}
      />
    );
  }

  return (
    <CustomerDeliveryRequestContainer
      shippingId={data.id}
      shipping={data}
      code={params.code}
      tracker={params.tracking}
      timeSlots={data.organizationTimeSlots}
    />
  );
};
